import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { IntroducingBrokerDashboardPage } from "./IntroducingBrokerDashboardPage";

export const IntroducingBrokerDashboardRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<IntroducingBrokerDashboardPage />} />
      <Route
        path="*"
        element={<Navigate to="/logged/dashboard" replace={true} />}
      />
    </Routes>
  );
};
